import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../../../page/teams/teams.component';
@Component({
	selector: 'app-delete-team-dialog',
	templateUrl: './delete-team-dialog.component.html',
	styleUrls: ['./delete-team-dialog.component.scss'],
	standalone: false,  // NOSONAR
})
export class DeleteTeamDialogComponent implements OnInit {
	selectedValue;
	selectedOption: number = 0;
	fileUploaded: File;
	storeData: any;
	worksheet: any;
	data: any;
	action;
	local_data;
	initial_data;
	pageName;
	error;
	enableError: boolean = false;
	teamName;
	constructor(public dialogRef: MatDialogRef<DeleteTeamDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public dataStore: DialogData) {
		console.info("data store", dataStore);
		this.pageName = dataStore.page;
		this.teamName = dataStore.teamName;
	}
	ngOnInit(): void { // NOSONAR
		//  do something 
	}
	public onChange(event): void {  // event will give you full breif of action
		this.selectedValue = event.target.value;
	}
	onNoClick(): void {
		this.dialogRef.close();
	}
	close(): void {
		this.dialogRef.close();
	}
	public deleteClick() {
		this.dialogRef.close({ data: this.teamName });
	}
}